import { CUSTOM_OBJECTS } from 'queries/query-keys';
import { useQuery } from '@tanstack/react-query';
import CustomObjectService from 'services/CustomObjectsService';

const useCustomObjectDetails = ({ objectId, enabled }) => {
  const { data, isLoading } = useQuery({
    queryKey: CUSTOM_OBJECTS.DETAILS(objectId),
    queryFn: () => CustomObjectService.getCustomObjectDetails(objectId),
    enabled: enabled && Boolean(objectId),
  });

  return { data, isLoading };
};

export default useCustomObjectDetails;
